import {
  BOT_CALCULATOR,
  CELL_CALCULATOR,
  FARM_TRACKER,
  LAB_CALCULATOR,
  MODULE_CALCULATOR,
  STAT_FINDER,
  STONE_CALCULATOR,
  WORKSHOP_CALCULATOR,
} from 'utils/constants';
import './footer.scss';

const Footer = () => (
  <div className='footer'>
    <div>
      If you are not on the Discord, join the Discord and get off Reddit. Do not
      trust Reddit, not even the post that sent you this, as it may be outdated.
      Also the wiki is not up to par, and is no longer properly maintained, it
      does not compare to the information in discord. I also suggest avoiding
      the player questions channel, as it is full of midgame players who tunnel
      vision on short term progress. My calculators will always be as up to date
      as allowed, and most of the other resources steal my data with some sort
      of lag time. Either use my resources found below, or come to discord.
      Updated info and changelogs will be found in my thread.
    </div>
    <div>This is up to date as of 0.27.3.0 ~Skye</div>
    <div>
      See my other guides:
      <a href={LAB_CALCULATOR}>Lab Calculator</a>
      <a href={STONE_CALCULATOR}>Stone Calculator</a>
      <a href={BOT_CALCULATOR}>Bot Calculator</a>
      <a href={WORKSHOP_CALCULATOR}>Workshop Calculator</a>
      <a href={MODULE_CALCULATOR}>Module Calculator</a>
      <a href={CELL_CALCULATOR}>Cell Calculator</a>
      <a href={STAT_FINDER}>Enemy Stat Finder</a>
      <a href={FARM_TRACKER}>Farm Tracker/Analyzer</a>
    </div>
  </div>
);

export default Footer;
